module.exports = __webpack_public_path__ + "static/quote-f4166d6deb69f09d49c3296dc379d622.png";